'use client';

import { useWindowSize } from 'usehooks-ts';
import { useRouter } from 'next/navigation'

import UiUtils from '@utils/ui';
import AuthService from '@services/auth';

import { IntroText } from '@constants/general';

import NavBar from '@components/nav-bar';
import Button from '@components/button';

export default function HomePage() {
   const { width } = useWindowSize();
   const isMobile = UiUtils.isMobile(width);
   const isDesktop = !isMobile;

   const router = useRouter()

   function doLogin() {
      if (AuthService.isLoggedIn()) {
         router.push("/admin");
      } else {
         router.push("/login");
      }
   }

   return (
      <>
         {isDesktop && (
            <div className="box-border w-full h-full py-6 flex flex-col items-stretch gap-10">
               <div className="box-border flex flex-col items-stretch gap-10 py-10 px-8 mx-16 rounded-3xl bg-[url(/images/home_hero_bg.png)] bg-right-bottom bg-contain bg-no-repeat bg-purple03">
                  <NavBar/>
                  <div className="w-full px-6 py-10 border-box max-w-content-narrow mx-auto">
                     <div className="flex flex-col items-start gap-8 max-w-[699px]">
                        <h1 className="font-vg-medium text-black !text-64px leading-110">
                           Seedkit Admin
                        </h1>
                        <p className="font-vg-regular text-black text-xl">
                           {AuthService.isLoggedIn() ? IntroText.LOGGED_IN : IntroText.LOGGED_OUT}
                        </p>
                        <Button 
                           variant="solid" 
                           size="large" 
                           label={AuthService.isLoggedIn() ? "GO TO ADMIN SITE" : "LOGIN"} 
                           rightIcon="ArrowRightIcon" 
                           className="min-w-[204px]" 
                           onClick={doLogin}
                        />
                     </div>
                  </div>
               </div>
            </div>
         )}
         {isMobile && (
            <div className="box-border w-full h-full py-6 flex flex-col items-stretch gap-8">
               <div className="box-border flex flex-col gap-8 pt-6 px-6 pb-12 rounded-3xl bg-[url(/images/home_hero_bg.png)]-mobile bg-right-bottom bg-contain bg-no-repeat bg-purple03 mx-5">
                  <NavBar/>
                  <div className="flex flex-col items-start gap-6">
                     <h1 className="font-vg-medium text-black !text-4xl">
                        Seedkit Admin
                     </h1>
                     <p className="font-vg-book text-black text-base">
                        {AuthService.isLoggedIn() ? IntroText.LOGGED_IN : IntroText.LOGGED_OUT}
                     </p>
                     <Button 
                        variant="solid" 
                        size="large" 
                        className="w-full" 
                        label={AuthService.isLoggedIn() ? "GO TO YOUR ACCOUNT" : "LOGIN"} 
                        rightIcon="ArrowRightIcon" 
                        onClick={doLogin}
                     />
                  </div>
               </div>
            </div>
         )}
      </>
   );
}
